import React, { useEffect, useRef, useState } from "react";
import { ChevronDownIcon } from "./icons";

const ListGroup = props => {
    const { isDisclosureItem = false, className, title, itemCount, tabIndex = 0, startOpen = true, disabled = false, indicatorPlacement = "right", onNavigationClick, children, icon, id } = props;
    const [isOpen, setIsOpen] = useState(startOpen);
    const [isCloseFocus, setCloseFocus] = useState(false);
    const groupRef = useRef();

    useEffect(() => {
        if (isCloseFocus) groupRef?.current?.focus();
    }, [isCloseFocus]);

    if (isDisclosureItem) {
        return (
            <li className={`ch-list-group ${disabled ? "ch-list-item-disabled" : ""} ${isOpen ? "ch-list-group-open" : "ch-list-group-closed"} ${className || ""}`}>
                <button
                    type="button"
                    id={id}
                    ref={groupRef}
                    className={`ch-list-group-head ${disabled ? "ch-list-item-disabled" : "ch-nav-item"}`}
                    onClick={() => {
                        if (!disabled) {
                            const open = !isOpen;
                            setIsOpen(open);
                            setCloseFocus(!open);
                        }
                    }}
                    aria-label={`${title}${itemCount ? ` ${itemCount} item${itemCount > 1 ? `s` : ``}` : ``}`}
                    aria-controls={`sub-list-${id}`}
                    aria-expanded={isOpen}
                    tabIndex={disabled ? -1 : tabIndex}
                    disabled={disabled}
                >
                    {!disabled && indicatorPlacement.toLowerCase() === "left" &&
                        <span className="ch-list-group-indicator"><ChevronDownIcon height={20} width={20} /></span>
                    }
                    <span className="ch-list-group-label">
                        {icon && <>{icon}</>}
                        <span>{title}</span>
                        {itemCount !== undefined && <span className="ch-list-group-badge">{itemCount}</span>}
                    </span>
                    {!disabled && indicatorPlacement.toLowerCase() === "right" &&
                        <span className="ch-list-group-indicator"><ChevronDownIcon height={20} width={20} /></span>
                    }
                </button>
                {isOpen &&
                    <ul id={`sub-list-${id}`} className="ch-sub-list ch-nav-group" aria-labelledby={id}>
                        {children}
                    </ul>
                }
            </li>
        );
    }

    return (
        <li role={'none'} className={"ch-list-group" + (disabled ? " ch-list-item-disabled" : "") + (isOpen ? " ch-list-group-open" : " ch-list-group-closed") + (className ? " " + className : "")}>
            <a
                id={id}
                ref={groupRef}
                className={"ch-list-group-head" + (disabled ? " ch-list-item-disabled" : " ch-nav-item")}
                onClick={() => {
                    const open = !isOpen && !disabled;
                    setIsOpen(open);
                    setCloseFocus(!open);
                    if (onNavigationClick) onNavigationClick();
                }}
                role="menuitem"
                aria-label={`${title}${itemCount ? ` ${itemCount} item${itemCount > 1 ? `s` : ``}` : ``}`}
                aria-expanded={isOpen}
                tabIndex={disabled ? -1 : tabIndex}
                disabled={disabled}
            >
                {!disabled && indicatorPlacement.toLowerCase() == "left" &&
                    <span className="ch-list-group-indicator">
                        <ChevronDownIcon height={20} width={20}/>
                    </span>
                }
                <span className="ch-list-group-label">
                    {icon &&
                        <>{icon}</>
                    }
                    <span>{title}</span>
                    {itemCount !== undefined &&
                        <span className="ch-list-group-badge">{itemCount}</span>
                    }
                </span>
                {!disabled && indicatorPlacement.toLowerCase() == "right" &&
                    <span className="ch-list-group-indicator">
                        <ChevronDownIcon height={20} width={20}/>
                    </span>
                }
            </a>
            {isOpen &&
                <ul className="ch-sub-list ch-nav-group" role="menu" aria-labelledby={id}>
                    {children}
                </ul>
            }
        </li>
    );
};

export default ListGroup;